import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  TOUR_SHOWING_STATUS_COMPLETED,
  TOUR_SHOWING_STATUS_WAITLIST,
} from 'common/tourConstants';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrCollapsibleRow from 'client/components/SrCollapsibleRow';
import SrDataTablePartnerStatTours from 'client/components/SrDataTablePartnerStatTours';
import SrDataTablePartnerStatRentlinxLeads from 'client/components/SrDataTablePartnerStatRentlinxLeads';
import SrDataTablePartnerStatSupraShowings from 'client/components/SrDataTablePartnerStatSupraShowings';

class SrPartnerStatsLeadsModal extends Component {
  static propTypes = {
    stats: PropTypes.object.isRequired,
    listingManagementCompany: PropTypes.string,
    listingId: PropTypes.number,
    apartmentId: PropTypes.number,
    sinceDate: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onRefreshStats: PropTypes.func.isRequired,
  }

  render() {
    const {
      stats,
      listingManagementCompany,
      listingId,
      apartmentId,
      sinceDate,
      onClose,
      onRefreshStats,
    } = this.props;

    const supraShowings = stats.supraShowings || 0;
    const srLeads = stats.srLeads || 0;
    const locatorTourLeads = stats.locatorTourLeads || 0;
    const rentlinxLeads = stats.rentlinxLeads || 0;

    return (
      <SrDarkModal>
        <SrModalContent width={1340} onCloseIconClick={onClose}>
          <SrCollapsibleRow title={`Supra Showings (${supraShowings} unique)`} collapsed>
            <SrDataTablePartnerStatSupraShowings
              listingManagementCompany={listingManagementCompany}
              listingId={listingId}
              apartmentId={apartmentId}
              sinceDate={sinceDate}
              onRefreshStats={onRefreshStats}
            />
          </SrCollapsibleRow>
          <SrCollapsibleRow
            title={`Sunroom Leads (${srLeads + locatorTourLeads} unique)`}
            collapsed
          >
            <SrDataTablePartnerStatTours
              listingManagementCompany={listingManagementCompany}
              listingId={listingId}
              apartmentId={apartmentId}
              sinceDate={sinceDate}
              onRefreshStats={onRefreshStats}
              nonRentlinxLeads
              showMessagesColumn
              tourStatus={[
                TOUR_SHOWING_STATUS_COMPLETED,
                TOUR_SHOWING_STATUS_WAITLIST,
              ]}
            />
          </SrCollapsibleRow>
          <SrCollapsibleRow title={`Rentlinx Leads (${rentlinxLeads} unique)`} collapsed>
            <SrDataTablePartnerStatRentlinxLeads
              listingManagementCompany={listingManagementCompany}
              listingId={listingId}
              apartmentId={apartmentId}
              sinceDate={sinceDate}
              onRefreshStats={onRefreshStats}
            />
          </SrCollapsibleRow>
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrPartnerStatsLeadsModal.displayName = 'SrPartnerStatsLeadsModal';

export default SrPartnerStatsLeadsModal;
